import styled from 'styled-components';

import { NavigationBar } from 'common/components/cookbook/NavigationBar/NavigationBar';
import { Stack } from 'common/components/cookbook/Stack';
import { Typography as T } from 'common/components/cookbook/Typography/Typography';
import { ViewMeta } from 'common/components/cookbook/ViewMeta';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

import girl_wires from './girl_wires.png';

const Content = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;

const StyledStack = styled(Stack)`
  max-width: 490px;
  text-align: center;
`;

const Illustration = styled.img`
  width: 240px;
  height: 160px;
`;

type Props = {
  viewTitle: string;
  titleContent?: React.ReactNode;
  showWarehouseSelector?: boolean;
  description?: string;
};

export const FeatureNotEnabledView = ({
  viewTitle,
  titleContent,
  showWarehouseSelector = true,
  description,
}: Props) => {
  const f = useFormatMessage();

  return (
    <ViewMeta title={viewTitle}>
      <NavigationBar
        title={viewTitle}
        showWarehouseSelector={showWarehouseSelector}
        titleContent={titleContent}
      />
      <Content>
        <StyledStack gap="broadXxlarge" alignItems="center">
          <Illustration src={girl_wires} alt="Girl illustration" />
          <Stack gap="regularXlarge">
            <T.Heading level={4} variant="headline">
              {f('common.feature_not_available')}
            </T.Heading>
            <div>{description}</div>
          </Stack>
        </StyledStack>
      </Content>
    </ViewMeta>
  );
};
